<section class="login-panel" aria-labelledby="login-title">
  <div class="login-copy">
    <p class="login-kicker">Acceso al visor</p>
    <h1 id="login-title">Selecciona tu perfil</h1>
  </div>

  <div class="login-options">
    @for (option of loginOptions; track option.key) {
      <button
        type="button"
        class="login-card"
        [class.irrigators]="option.key === 'irrigators'"
        [class.guards]="option.key === 'guards'"
        [class.managers]="option.key === 'managers'"
        (click)="profileSelected.emit(option)"
        [attr.aria-label]="'Acceder como ' + option.title"
      >
        <span class="login-icon" aria-hidden="true">
          <img [src]="getProfileIconPath(option.key)" [alt]="option.title" />
        </span>
        <strong>{{ option.title }}</strong>
        <span>{{ option.subtitle }}</span>
      </button>
    }
  </div>
</section>
